// extracted by mini-css-extract-plugin
export default {"ConteneurInfo":"ConteneurInformation_ConteneurInfo__qTKjh","stile":"ConteneurInformation_stile__JV2e3","newSlil":"ConteneurInformation_newSlil__ZM+Hm"};